import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as globals from '../training/globals';

const baseUrl = `${environment.apis.cds}/${globals.CDS}`;

@Injectable({
  providedIn: 'root',
})

export class CdsService {
  constructor(
    private http: HttpClient) { }

  setup(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.SETUP}`, data);
  }

  run(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.RUN}`, data);
  }

  stop(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.STOP}`, data);
  }

  cleanup(data: any): Observable<any> {
    return this.http.post(`${baseUrl}/${globals.CLEANUP}`, data);
  }
}
